var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChildren(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6968 21C32.6968 27.207 27.6187 32.25 21.3406 32.25C15.0625 32.25 9.98438 27.207 9.98438 21C9.98438 14.793 15.0625 9.75 21.3406 9.75C27.6187 9.75 32.6968 14.793 32.6968 21Z",
    stroke: "#68768B",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8281 16.58C13.0101 16.58 17.344 16.106 21.66 14.5086M27.3945 11.5273C25.6277 12.801 23.6457 13.7737 21.66 14.5086M21.66 14.5086C22.7219 16.0412 25.5467 17.5905 32.1733 16.58",
    stroke: "#68768B",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5493 24.7891C26.5493 24.3748 26.2135 24.0391 25.7993 24.0391C25.385 24.0391 25.0493 24.3748 25.0493 24.7891H26.5493ZM17.6289 24.7891C17.6289 24.3748 17.2931 24.0391 16.8789 24.0391C16.4647 24.0391 16.1289 24.3748 16.1289 24.7891H17.6289ZM25.0493 24.7891C25.0493 26.3578 23.5074 27.8285 21.3391 27.8285V29.3285C24.0973 29.3285 26.5493 27.4061 26.5493 24.7891H25.0493ZM21.3391 27.8285C19.1708 27.8285 17.6289 26.3578 17.6289 24.7891H16.1289C16.1289 27.4061 18.5808 29.3285 21.3391 29.3285V27.8285Z",
    fill: "#68768B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8086 24.1569C34.3921 24.1569 35.6758 22.8844 35.6758 21.3148C35.6758 19.7451 34.3921 18.4727 32.8086 18.4727",
    stroke: "#68768B",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1914 24.1569C8.60786 24.1569 7.32415 22.8844 7.32415 21.3148C7.32415 19.7451 8.60786 18.4727 10.1914 18.4727",
    stroke: "#68768B",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96018 22.8945C6.47345 23.2103 3.5 25.5472 3.5 32.3682C5.30531 32.4735 9.29823 31.3577 10.8274 26.0524",
    stroke: "#68768B",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0398 22.8945C36.5265 23.2103 39.5 25.5472 39.5 32.3682C37.6947 32.4735 33.3832 31.0419 31.854 25.7366",
    stroke: "#68768B",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildren);
export default __webpack_public_path__ + "static/media/children.750160efa9d19bf7332db02da628a09f.svg";
export { ForwardRef as ReactComponent };